import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	adminUsersByIdReducers,
	adminUsersByIdWatchers } from './_id';

export const adminUsersReducers = combineReducers({
	byId: adminUsersByIdReducers
});

export const adminUsersWatchers = combineAllWatchers([
	adminUsersByIdWatchers
]);
